<mf-page title="Editar persona">
  @if (naturalPersonDto) {
  <mf-natural-person
    [naturalPersonDto]="naturalPersonDto"
    (save)="save($event)" />
  }
</mf-page>
